import { Injectable, computed, inject, signal } from '@angular/core';
import { WorkflowDraftConfirmationService } from '../workflow-registry-diagnostics/workflow-draft-confirmation.service';

@Injectable({ providedIn: 'root' })
export class NoticeFidelityStateService {
  private readonly confirmation = inject(WorkflowDraftConfirmationService);
  readonly dirty = signal(false);
  readonly busy = signal(false);
  readonly isNavigationBlocked = computed(() => this.dirty() || this.busy());
  confirmNavigation(): boolean | Promise<boolean> {
    if (this.busy()) return false;
    if (!this.dirty()) return true;
    return this.confirmation.confirm({
      heading: 'Leave notice composition edits?',
      message: 'Unsaved local notice composition changes will be lost.',
      confirmText: 'Leave without saving',
      cancelText: 'Stay on page',
    });
  }
}
